import React from "react";
import ReactExport from "react-data-export";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getPimaData,
  getPimaDataDec2021,
  getPimaDataNov2021,
  getPimaDataOct2021,
  getPimaDataSep2021,
  getPimaDataAgo2021,
  getPimaDataJul2021,
  getPimaDataJun2021,
  getPimaDataMay2021,
  getPimaDataApr2021,
  getPimaDataMar2021,
  getPimaDataFeb2021,
  getPimaDataJan2021,
  getPimaDataDec2020,
  getPimaDataNov2020,
  getPimaDataOct2020,
  getPimaDataSep2020,
  getPimaDataAgo2020,
  getPimaDataJul2020,
  getPimaDataJun2020,
  getPimaDataMay2020,
  getPimaDataApr2020,
  getPimaDataMar2020,
} from "../../actions/pimadataActions";
import {
  getArizonaData,
  getArizonaDataDec2021,
  getArizonaDataNov2021,
  getArizonaDataOct2021,
  getArizonaDataSep2021,
  getArizonaDataAgo2021,
  getArizonaDataJul2021,
  getArizonaDataJun2021,
  getArizonaDataMay2021,
  getArizonaDataApr2021,
  getArizonaDataMar2021,
  getArizonaDataFeb2021,
  getArizonaDataJan2021,
  getArizonaDataDec2020,
  getArizonaDataNov2020,
  getArizonaDataOct2020,
  getArizonaDataSep2020,
  getArizonaDataAgo2020,
  getArizonaDataJul2020,
  getArizonaDataJun2020,
  getArizonaDataMay2020,
  getArizonaDataApr2020,
  getArizonaDataMar2020,
} from "../../actions/arizonadataActions";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends React.Component {
  componentDidMount() {
    this.props.getPimaData();
    this.props.getArizonaData();
    this.props.getPimaDataDec2021();
    this.props.getPimaDataNov2021();
    this.props.getPimaDataOct2021();
    this.props.getPimaDataSep2021();
    this.props.getPimaDataAgo2021();
    this.props.getPimaDataJul2021();
    this.props.getPimaDataJun2021();
    this.props.getPimaDataMay2021();
    this.props.getPimaDataApr2021();
    this.props.getPimaDataMar2021();
    this.props.getPimaDataFeb2021();
    this.props.getPimaDataJan2021();
    this.props.getPimaDataDec2020();
    this.props.getPimaDataNov2020();
    this.props.getPimaDataOct2020();
    this.props.getPimaDataSep2020();
    this.props.getPimaDataAgo2020();
    this.props.getPimaDataJul2020();
    this.props.getPimaDataJun2020();
    this.props.getPimaDataMay2020();
    this.props.getPimaDataApr2020();
    this.props.getPimaDataMar2020();
    this.props.getArizonaDataDec2021();
    this.props.getArizonaDataNov2021();
    this.props.getArizonaDataOct2021();
    this.props.getArizonaDataSep2021();
    this.props.getArizonaDataAgo2021();
    this.props.getArizonaDataJul2021();
    this.props.getArizonaDataJun2021();
    this.props.getArizonaDataMay2021();
    this.props.getArizonaDataApr2021();
    this.props.getArizonaDataMar2021();
    this.props.getArizonaDataFeb2021();
    this.props.getArizonaDataJan2021();
    this.props.getArizonaDataDec2020();
    this.props.getArizonaDataNov2020();
    this.props.getArizonaDataOct2020();
    this.props.getArizonaDataSep2020();
    this.props.getArizonaDataAgo2020();
    this.props.getArizonaDataJul2020();
    this.props.getArizonaDataJun2020();
    this.props.getArizonaDataMay2020();
    this.props.getArizonaDataApr2020();
    this.props.getArizonaDataMar2020();
  }
  render() {
    const { pimadatas, arizonadatas } = this.props;
    const pimaDataSet = [];
    const arizonaDataSet = [];
    const weeklyAvgs = [];
    var pp = "";
    var number_of_vaccines_pima = "-";
    var new_vaccines_today_pima = "-";
    var percent_of_people_vaccinated_pima = "-";
    var number_of_vaccines = "-";
    var new_vaccines_today = "-";
    var percent_of_people_vaccinated = "-";

    // PIMA DAILY NUMBERS
    for (var i = 0; i < pimadatas.length; i++) {
      if (pimadatas[i].percent_positive_pima.includes("%")) {
        pp = pimadatas[i].percent_positive_pima;
      } else {
        pp = `${pimadatas[i].percent_positive_pima}%`;
      }
      if (pimadatas[i].number_of_vaccines_pima) {
        number_of_vaccines_pima = pimadatas[i].number_of_vaccines_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      if (pimadatas[i].new_vaccines_today_pima) {
        new_vaccines_today_pima = pimadatas[i].new_vaccines_today_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      if (pimadatas[i].percent_of_people_vaccinated_pima) {
        percent_of_people_vaccinated_pima = pimadatas[
          i
        ].percent_of_people_vaccinated_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      pimaDataSet.push({
        date: `${pimadatas[i].date.month}/${pimadatas[i].date.day}/${pimadatas[i].date.year}`,
        cases: pimadatas[i].number_of_cases_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        new_cases: pimadatas[i].new_cases_today_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        cases_100k: pimadatas[i].rate_cases_100k_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        deaths: pimadatas[i].number_of_deaths_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        new_deaths: pimadatas[i].new_deaths_today_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        deaths_100k: pimadatas[i].rate_deaths_100k_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        number_of_vaccines: number_of_vaccines_pima,
        new_vaccines: new_vaccines_today_pima,
        people_vaccinated: percent_of_people_vaccinated_pima,
        tests: pimadatas[i].number_of_test_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        new_tests: pimadatas[i].new_test_today_pima
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        positivity: pp,
      });
    }

    // ARIZONA DAILY NUMBERS
    for (i = 0; i < arizonadatas.length; i++) {
      if (arizonadatas[i].percent_positive.includes("%")) {
        pp = arizonadatas[i].percent_positive;
      } else {
        pp = `${arizonadatas[i].percent_positive}%`;
      }
      if (arizonadatas[i].number_of_vaccines) {
        number_of_vaccines = arizonadatas[i].number_of_vaccines
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      if (arizonadatas[i].new_vaccines_today) {
        new_vaccines_today = arizonadatas[i].new_vaccines_today
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      if (arizonadatas[i].percent_of_people_vaccinated) {
        percent_of_people_vaccinated = arizonadatas[
          i
        ].percent_of_people_vaccinated
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      arizonaDataSet.push({
        date: `${arizonadatas[i].date.month}/${arizonadatas[i].date.day}/${arizonadatas[i].date.year}`,
        cases: arizonadatas[i].number_of_cases
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        new_cases: arizonadatas[i].new_cases_today
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        cases_100k: arizonadatas[i].rate_cases_100k
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        deaths: arizonadatas[i].number_of_deaths
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        new_deaths: arizonadatas[i].new_deaths_today
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        deaths_100k: arizonadatas[i].rate_deaths_100k
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        number_of_vaccines: number_of_vaccines,
        new_vaccines: new_vaccines_today,
        people_vaccinated: percent_of_people_vaccinated,
        tests: arizonadatas[i].number_of_test
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        new_tests: arizonadatas[i].new_test_today
          .replace(/,/g, "")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"),
        positivity: pp,
      });
    }

    // AZ-PIMA WEEKLY AVERAGES
    const weeks = [];
    if (pimadatas.length % 7 === 0) {
      var weeksSize = pimadatas.length / 7;
    } else {
      weeksSize = Math.floor(pimadatas.length / 7) + 1;
    }
    for (var j = 13; j <= weeksSize + 12; j++) {
      weeks.push(j);
    }

    const weeksText = [
      "MAR22 - MAR28",
      "MAR29 - APR04",
      "APR05 - APR11",
      "APR12 - APR18",
      "APR19 - APR25",
      "APR26 - MAY02",
      "MAY03 - MAY09",
      "MAY10 - MAY16",
      "MAY17 - MAY23",
      "MAY24 - MAY30",
      "MAY31 - JUN06",
      "JUN07 - JUN13",
      "JUN14 - JUN20",
      "JUN21 - JUN27",
      "JUN28 - JUL04",
      "JUL05 - JUL11",
      "JUL12 - JUL18",
      "JUL19 - JUL25",
      "JUL26 - AUG01",
      "AUG02 - AUG08",
      "AUG09 - AUG15",
      "AUG16 - AUG22",
      "AUG23 - AUG29",
      "AUG30 - SEP05",
      "SEP06 - SEP12",
      "SEP13 - SEP19",
      "SEP20 - SEP26",
      "SEP27 - OCT03",
      "OCT04 - OCT10",
      "OCT11 - OCT17",
      "OCT18 - OCT24",
      "OCT25 - OCT31",
      "NOV01 - NOV07",
      "NOV08 - NOV14",
      "NOV15 - NOV21",
      "NOV22 - NOV28",
      "NOV29 - DEC05",
      "DEC06 - DEC12",
      "DEC13 - DEC19",
      "DEC20 - DEC26",
      "DEC27 - JAN02",
      "JAN03 - JAN09",
      "JAN10 - JAN16",
      "JAN17 - JAN23",
      "JAN24 - JAN30",
      "JAN31 - FEB06",
      "FEB07 - FEB13",
      "FEB14 - FEB20",
      "FEB21 - FEB27",
      "FEB28 - MAR06",
      "MAR07 - MAR13",
      "MAR14 - MAR20",
      "MAR21 - MAR27",
      "MAR28 - APR03",
      "APR04 - APR10",
      "APR11 - APR17",
      "APR18 - APR24",
      "APR25 - MAY01",
      "MAY02 - MAY08",
      "MAY09 - MAY15",
      "MAY16 - MAY22",
      "MAY23 - MAY29",
      "MAY30 - JUN05",
      "JUN06 - JUN12",
      "JUN13 - JUN19",
      "JUN20 - JUN26",
      "JUN27 - JUL03",
      "JUL04 - JUL10",
      "JUL11 - JUL17",
      "JUL18 - JUL24",
      "JUL25 - JUL31",
      "AUG01 - AUG07",
      "AUG08 - AUG14",
      "AUG09 - AUG21",
      "AUG10 - AUG28",
      "AUG29 - SEP04",
      "SEP05 - SEP11",
      "SEP12 - SEP18",
      "SEP19 - SEP25",
      "SEP26 - OCT02",
      "OCT03 - OCT09",
      "OCT10 - OCT16",
      "OCT17 - OCT23",
      "OCT24 - OCT30",
      "OCT31 - NOV06",
      "NOV07 - NOV13",
      "NOV14 - NOV20",
      "NOV21 - NOV27",
      "NOV28 - DEC04",
      "DEC05 - DEC11",
      "DEC12 - DEC18",
      "DEC19 - DEC25",
      "DEC26 - JAN01",
    ];

    var pimaAvgs = [];
    var pimaAvgsText = [];
    for (i = 0; i < pimadatas.length; i++) {
      if (i % 7 === 0) {
        var sum = 0;
        var divisor = 0;
        if (pimadatas[i] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 1] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 1].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 2] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 2].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 3] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 3].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 4] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 4].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 5] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 5].new_cases_today_pima.replace(/,/g, ""));
        }
        if (pimadatas[i + 6] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(pimadatas[i + 6].new_cases_today_pima.replace(/,/g, ""));
        }

        var average = Math.trunc((sum / divisor + Number.EPSILON) * 100) / 100;

        pimaAvgs.push(Math.floor(average));
        pimaAvgsText.push(
          Math.floor(average)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        );
      }
    }
    var arizonaAvgs = [];
    var arizonaAvgsText = [];
    for (i = 0; i < arizonadatas.length; i++) {
      if (i % 7 === 0) {
        sum = 0;
        divisor = 0;
        if (arizonadatas[i] !== undefined) {
          divisor++;
          sum =
            sum + parseFloat(arizonadatas[i].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 1] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 1].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 2] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 2].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 3] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 3].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 4] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 4].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 5] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 5].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 6] !== undefined) {
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 6].new_cases_today.replace(/,/g, ""));
        }

        average = Math.trunc((sum / divisor + Number.EPSILON) * 100) / 100;

        arizonaAvgs.push(Math.floor(average));
        arizonaAvgsText.push(
          Math.floor(average)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        );
      }
    }

    for (var x = 0; x < weeks.length; x++) {
      weeklyAvgs.push({
        week: weeks[x],
        weekText: weeksText[x],
        pimaWA: pimaAvgsText[x],
        arizonaWA: arizonaAvgsText[x],
      });
    }

    // AZ-PIMA MONTHLY CASES
    const monthlyCases = [];

    const {
      pdmar2020,
      pdapr2020,
      pdmay2020,
      pdjun2020,
      pdjul2020,
      pdago2020,
      pdsep2020,
      pdoct2020,
      pdnov2020,
      pddec2020,
      pdjan2021,
      pdfeb2021,
      pdmar2021,
      pdapr2021,
      pdmay2021,
      pdjun2021,
      pdjul2021,
      pdago2021,
      pdsep2021,
      pdoct2021,
      pdnov2021,
      pddec2021,
      azmar2020,
      azapr2020,
      azmay2020,
      azjun2020,
      azjul2020,
      azago2020,
      azsep2020,
      azoct2020,
      aznov2020,
      azdec2020,
      azjan2021,
      azfeb2021,
      azmar2021,
      azapr2021,
      azmay2021,
      azjun2021,
      azjul2021,
      azago2021,
      azsep2021,
      azoct2021,
      aznov2021,
      azdec2021,
    } = this.props;

    const pds2021 = [
      pdmar2020,
      pdapr2020,
      pdmay2020,
      pdjun2020,
      pdjul2020,
      pdago2020,
      pdsep2020,
      pdoct2020,
      pdnov2020,
      pddec2020,
      pdjan2021,
      pdfeb2021,
      pdmar2021,
      pdapr2021,
      pdmay2021,
      pdjun2021,
      pdjul2021,
      pdago2021,
      pdsep2021,
      pdoct2021,
      pdnov2021,
      pddec2021,
    ];

    const pimaMonthlySums = [];
    var countMonths = 0;
    sum = 0;
    for (x = 0; x < pds2021.length; x++) {
      if (pds2021[x].length > 0) {
        sum = 0;
        for (var z = 0; z < pds2021[x].length; z++) {
          sum =
            sum +
            parseFloat(pds2021[x][z].new_cases_today_pima.replace(/,/g, ""));
        }
        pimaMonthlySums.push(
          sum.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        );
        countMonths++;
      }
    }

    const azs2021 = [
      azmar2020,
      azapr2020,
      azmay2020,
      azjun2020,
      azjul2020,
      azago2020,
      azsep2020,
      azoct2020,
      aznov2020,
      azdec2020,
      azjan2021,
      azfeb2021,
      azmar2021,
      azapr2021,
      azmay2021,
      azjun2021,
      azjul2021,
      azago2021,
      azsep2021,
      azoct2021,
      aznov2021,
      azdec2021,
    ];
    const azMonthlySums = [];

    for (x = 0; x < azs2021.length; x++) {
      if (azs2021[x].length > 0) {
        sum = 0;
        for (z = 0; z < azs2021[x].length; z++) {
          sum =
            sum + parseFloat(azs2021[x][z].new_cases_today.replace(/,/g, ""));
        }
        azMonthlySums.push(
          sum.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        );
      }
    }

    const allMonths = [
      "Mar 20",
      "Apr 20",
      "May 20",
      "Jun 20",
      "Jul 20",
      "Ago 20",
      "Sep 20",
      "Oct 20",
      "Nov 20",
      "Dec 20",
      "Jan 21",
      "Feb 21",
      "Mar 21",
      "Apr 21",
      "May 21",
      "Jun 21",
      "Jul 21",
      "Ago 21",
      "Sep 21",
      "Oct 21",
      "Nov 21",
      "Dec 21",
    ];
    for (x = 0; x < countMonths; x++) {
      monthlyCases.push({
        month: allMonths[x],
        pimaMonthlyCases: pimaMonthlySums[x],
        azMonthlyCases: azMonthlySums[x],
      });
    }

    // GET TODAYS DATE
    var today = new Date();
    if (today.getHours() > 9) {
      var dd = today.getDate();

      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      var date = mm + "-" + dd + "-" + yyyy;
    } else if (today.getHours() === 9) {
      if (today.getMinutes() < 29) {
        var yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        dd = yesterday.getDate();
        mm = yesterday.getMonth() + 1;
        yyyy = yesterday.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }
        date = mm + "-" + dd + "-" + yyyy;
      } else {
        dd = today.getDate();

        mm = today.getMonth() + 1;
        yyyy = today.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }
        date = mm + "-" + dd + "-" + yyyy;
      }
    } else {
      yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      dd = yesterday.getDate();
      mm = yesterday.getMonth() + 1;
      yyyy = yesterday.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      date = mm + "-" + dd + "-" + yyyy;
    }
    var filename = `AZ-PIMA COVID-19 Data-${date}`;

    return (
      <ExcelFile
        element={
          <li className="nav-item">
            <a href="#!" className="nav-link ">
              <i className="far fa-save" /> Download Data
            </a>
          </li>
        }
        filename={filename}
      >
        <ExcelSheet data={pimaDataSet.reverse()} name="Pima Daily Numbers">
          <ExcelColumn label="Date" value="date" />
          <ExcelColumn label="# Cases" value="cases" />
          <ExcelColumn label="New Cases" value="new_cases" />
          <ExcelColumn label="Rate 100k Cases" value="cases_100k" />
          <ExcelColumn label="# Deaths" value="deaths" />
          <ExcelColumn label="New Deaths" value="new_deaths" />
          <ExcelColumn label="Rate 100k Deaths" value="deaths_100k" />
          <ExcelColumn label="# Vaccines" value="number_of_vaccines" />
          <ExcelColumn label="New Vaccines" value="new_vaccines" />
          <ExcelColumn label="% People Vaccinated" value="people_vaccinated" />
          <ExcelColumn label="# Tests" value="tests" />
          <ExcelColumn label="New Tests" value="new_tests" />
          <ExcelColumn label="% Positivity" value="positivity" />
        </ExcelSheet>
        <ExcelSheet
          data={arizonaDataSet.reverse()}
          name="Arizona Daily Numbers"
        >
          <ExcelColumn label="Date" value="date" />
          <ExcelColumn label="# Cases" value="cases" />
          <ExcelColumn label="New Cases" value="new_cases" />
          <ExcelColumn label="Rate 100k Cases" value="cases_100k" />
          <ExcelColumn label="# Deaths" value="deaths" />
          <ExcelColumn label="New Deaths" value="new_deaths" />
          <ExcelColumn label="Rate 100k Deaths" value="deaths_100k" />
          <ExcelColumn label="# Vaccines" value="number_of_vaccines" />
          <ExcelColumn label="New Vaccines" value="new_vaccines" />
          <ExcelColumn label="% People Vaccinated" value="people_vaccinated" />
          <ExcelColumn label="# Tests" value="tests" />
          <ExcelColumn label="New Tests" value="new_tests" />
          <ExcelColumn label="% Positivity" value="positivity" />
        </ExcelSheet>
        <ExcelSheet data={weeklyAvgs.reverse()} name="AZ-Pima Weekly Averages">
          <ExcelColumn label="Epidemiological Week" value="week" />
          <ExcelColumn label="Dates" value="weekText" />
          <ExcelColumn label="Pima Weekly Avg." value="pimaWA" />
          <ExcelColumn label="AZ Weekly Avg." value="arizonaWA" />
        </ExcelSheet>
        <ExcelSheet data={monthlyCases.reverse()} name="AZ-Pima Monthly Cases">
          <ExcelColumn label="Month" value="month" />
          <ExcelColumn label="Pima Monthly Cases" value="pimaMonthlyCases" />
          <ExcelColumn label="Arizona Monthly Cases" value="azMonthlyCases" />
        </ExcelSheet>
      </ExcelFile>
    );
  }
}

Download.propTypes = {
  getPimaData: PropTypes.func.isRequired,
  getArizonaData: PropTypes.func.isRequired,
  pimadatas: PropTypes.array.isRequired,
  arizonadatas: PropTypes.array.isRequired,
  getPimaDataJan2021: PropTypes.func.isRequired,
  getPimaDataDec2020: PropTypes.func.isRequired,
  getPimaDataNov2020: PropTypes.func.isRequired,
  getPimaDataOct2020: PropTypes.func.isRequired,
  getPimaDataSep2020: PropTypes.func.isRequired,
  getPimaDataAgo2020: PropTypes.func.isRequired,
  getPimaDataJul2020: PropTypes.func.isRequired,
  getPimaDataJun2020: PropTypes.func.isRequired,
  getPimaDataMay2020: PropTypes.func.isRequired,
  getPimaDataApr2020: PropTypes.func.isRequired,
  getPimaDataMar2020: PropTypes.func.isRequired,
  getPimaDataFeb2021: PropTypes.func.isRequired,
  getPimaDataDec2021: PropTypes.func.isRequired,
  getPimaDataNov2021: PropTypes.func.isRequired,
  getPimaDataOct2021: PropTypes.func.isRequired,
  getPimaDataSep2021: PropTypes.func.isRequired,
  getPimaDataAgo2021: PropTypes.func.isRequired,
  getPimaDataJul2021: PropTypes.func.isRequired,
  getPimaDataJun2021: PropTypes.func.isRequired,
  getPimaDataMay2021: PropTypes.func.isRequired,
  getPimaDataApr2021: PropTypes.func.isRequired,
  getPimaDataMar2021: PropTypes.func.isRequired,
  pdjan2021: PropTypes.array.isRequired,
  pddec2020: PropTypes.array.isRequired,
  pdnov2020: PropTypes.array.isRequired,
  pdoct2020: PropTypes.array.isRequired,
  pdsep2020: PropTypes.array.isRequired,
  pdago2020: PropTypes.array.isRequired,
  pdjul2020: PropTypes.array.isRequired,
  pdjun2020: PropTypes.array.isRequired,
  pdmay2020: PropTypes.array.isRequired,
  pdapr2020: PropTypes.array.isRequired,
  pdmar2020: PropTypes.array.isRequired,
  pdfeb2021: PropTypes.array.isRequired,
  pddec2021: PropTypes.array.isRequired,
  pdnov2021: PropTypes.array.isRequired,
  pdoct2021: PropTypes.array.isRequired,
  pdsep2021: PropTypes.array.isRequired,
  pdago2021: PropTypes.array.isRequired,
  pdjul2021: PropTypes.array.isRequired,
  pdjun2021: PropTypes.array.isRequired,
  pdmay2021: PropTypes.array.isRequired,
  pdapr2021: PropTypes.array.isRequired,
  pdmar2021: PropTypes.array.isRequired,
  getArizonaDataJan2021: PropTypes.func.isRequired,
  getArizonaDataDec2020: PropTypes.func.isRequired,
  getArizonaDataNov2020: PropTypes.func.isRequired,
  getArizonaDataOct2020: PropTypes.func.isRequired,
  getArizonaDataSep2020: PropTypes.func.isRequired,
  getArizonaDataAgo2020: PropTypes.func.isRequired,
  getArizonaDataJul2020: PropTypes.func.isRequired,
  getArizonaDataJun2020: PropTypes.func.isRequired,
  getArizonaDataMay2020: PropTypes.func.isRequired,
  getArizonaDataApr2020: PropTypes.func.isRequired,
  getArizonaDataMar2020: PropTypes.func.isRequired,
  getArizonaDataFeb2021: PropTypes.func.isRequired,
  getArizonaDataDec2021: PropTypes.func.isRequired,
  getArizonaDataNov2021: PropTypes.func.isRequired,
  getArizonaDataOct2021: PropTypes.func.isRequired,
  getArizonaDataSep2021: PropTypes.func.isRequired,
  getArizonaDataAgo2021: PropTypes.func.isRequired,
  getArizonaDataJul2021: PropTypes.func.isRequired,
  getArizonaDataJun2021: PropTypes.func.isRequired,
  getArizonaDataMay2021: PropTypes.func.isRequired,
  getArizonaDataApr2021: PropTypes.func.isRequired,
  getArizonaDataMar2021: PropTypes.func.isRequired,
  azjan2021: PropTypes.array.isRequired,
  azdec2020: PropTypes.array.isRequired,
  aznov2020: PropTypes.array.isRequired,
  azoct2020: PropTypes.array.isRequired,
  azsep2020: PropTypes.array.isRequired,
  azago2020: PropTypes.array.isRequired,
  azjul2020: PropTypes.array.isRequired,
  azjun2020: PropTypes.array.isRequired,
  azmay2020: PropTypes.array.isRequired,
  azapr2020: PropTypes.array.isRequired,
  azmar2020: PropTypes.array.isRequired,
  azfeb2021: PropTypes.array.isRequired,
  azdec2021: PropTypes.array.isRequired,
  aznov2021: PropTypes.array.isRequired,
  azoct2021: PropTypes.array.isRequired,
  azsep2021: PropTypes.array.isRequired,
  azago2021: PropTypes.array.isRequired,
  azjul2021: PropTypes.array.isRequired,
  azjun2021: PropTypes.array.isRequired,
  azmay2021: PropTypes.array.isRequired,
  azapr2021: PropTypes.array.isRequired,
  azmar2021: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
  pimadatas: state.pimadata.pimadatas,
  arizonadatas: state.arizonadata.arizonadatas,
  pdjan2021: state.pimadata.pdjan2021,
  pddec2020: state.pimadata.pddec2020,
  pdnov2020: state.pimadata.pdnov2020,
  pdoct2020: state.pimadata.pdoct2020,
  pdsep2020: state.pimadata.pdsep2020,
  pdago2020: state.pimadata.pdago2020,
  pdjul2020: state.pimadata.pdjul2020,
  pdjun2020: state.pimadata.pdjun2020,
  pdmay2020: state.pimadata.pdmay2020,
  pdapr2020: state.pimadata.pdapr2020,
  pdmar2020: state.pimadata.pdmar2020,
  pdfeb2021: state.pimadata.pdfeb2021,
  pddec2021: state.pimadata.pddec2021,
  pdnov2021: state.pimadata.pdnov2021,
  pdoct2021: state.pimadata.pdoct2021,
  pdsep2021: state.pimadata.pdsep2021,
  pdago2021: state.pimadata.pdago2021,
  pdjul2021: state.pimadata.pdjul2021,
  pdjun2021: state.pimadata.pdjun2021,
  pdmay2021: state.pimadata.pdmay2021,
  pdapr2021: state.pimadata.pdapr2021,
  pdmar2021: state.pimadata.pdmar2021,
  azjan2021: state.arizonadata.azjan2021,
  azdec2020: state.arizonadata.azdec2020,
  aznov2020: state.arizonadata.aznov2020,
  azoct2020: state.arizonadata.azoct2020,
  azsep2020: state.arizonadata.azsep2020,
  azago2020: state.arizonadata.azago2020,
  azjul2020: state.arizonadata.azjul2020,
  azjun2020: state.arizonadata.azjun2020,
  azmay2020: state.arizonadata.azmay2020,
  azapr2020: state.arizonadata.azapr2020,
  azmar2020: state.arizonadata.azmar2020,
  azfeb2021: state.arizonadata.azfeb2021,
  azdec2021: state.arizonadata.azdec2021,
  aznov2021: state.arizonadata.aznov2021,
  azoct2021: state.arizonadata.azoct2021,
  azsep2021: state.arizonadata.azsep2021,
  azago2021: state.arizonadata.azago2021,
  azjul2021: state.arizonadata.azjul2021,
  azjun2021: state.arizonadata.azjun2021,
  azmay2021: state.arizonadata.azmay2021,
  azapr2021: state.arizonadata.azapr2021,
  azmar2021: state.arizonadata.azmar2021,
});

export default connect(mapStateToProps, {
  getPimaData,
  getArizonaData,
  getPimaDataAgo2020,
  getPimaDataApr2020,
  getPimaDataDec2020,
  getPimaDataJan2021,
  getPimaDataJul2020,
  getPimaDataJun2020,
  getPimaDataMar2020,
  getPimaDataMay2020,
  getPimaDataNov2020,
  getPimaDataOct2020,
  getPimaDataSep2020,
  getPimaDataAgo2021,
  getPimaDataApr2021,
  getPimaDataDec2021,
  getPimaDataFeb2021,
  getPimaDataJul2021,
  getPimaDataJun2021,
  getPimaDataMar2021,
  getPimaDataMay2021,
  getPimaDataNov2021,
  getPimaDataOct2021,
  getPimaDataSep2021,
  getArizonaDataAgo2020,
  getArizonaDataApr2020,
  getArizonaDataDec2020,
  getArizonaDataJan2021,
  getArizonaDataJul2020,
  getArizonaDataJun2020,
  getArizonaDataMar2020,
  getArizonaDataMay2020,
  getArizonaDataNov2020,
  getArizonaDataOct2020,
  getArizonaDataSep2020,
  getArizonaDataAgo2021,
  getArizonaDataApr2021,
  getArizonaDataDec2021,
  getArizonaDataFeb2021,
  getArizonaDataJul2021,
  getArizonaDataJun2021,
  getArizonaDataMar2021,
  getArizonaDataMay2021,
  getArizonaDataNov2021,
  getArizonaDataOct2021,
  getArizonaDataSep2021,
})(Download);
